export default __webpack_public_path__ + "static/media/site_logo.e49d641b.png";